import { IDay } from '../types';

export const daysAreEqual = (first?: IDay, second?: IDay) => {
  return (
    first &&
    second &&
    first.day === second.day &&
    first.month === second.month &&
    first.year === second.year
  );
};
